const ComponentBase=require('../../base/ComponentBase');
const GeometryUtil=require('../../utils/GeometryUtil');
const CommonUtil=require('../../utils/CommonUtil');
const RenderUtil=require('../../utils/RenderUtil');
const g2=require('../../g2');
const BufferTool = require('./tools/BufferTool');
const BufferDragTool = require('./tools/BufferDragTool');
const BufferCloseTool = require('./tools/BufferCloseTool');

/**
 * @constructor
 * @classdesc 缓冲区
 * @augments G.base.ComponentBase
 * @alias G.interact.Buffer
 * @param {Object} options - 必填，构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {String} [options.id] 标识
 * @param {String} [options.name] 名称
 * @param {String} [options.buffer_img] 缓冲区半径调整图标base64
 * @param {String} [options.close_img] 缓冲区关闭图标base64
 * @param {g2.carto.ElementLayer} [options.layer] 缓冲图层
 * @param {Integer} [options.zIndex] 缓冲图层z-index
 * @param {Float} [options.radius] 缓冲半径，单位为米
 * @param {Function} [options.callback] 回调函数
 * @param {Function} [options.onClose] 关闭
 * @param {Object} [options.drag] 缓冲图层半径调节按钮
 * @param {Boolean} options.drag.visible 缓冲图层半径调节按钮是否可见
 * @param {Object} options.drag.style 缓冲图层半径调节按钮样式
 * @param {Object} [options.close] 缓冲图层关闭按钮
 * @param {Boolean} options.close.visible 缓冲图层关闭按钮是否可见
 * @param {Object} options.close.style 缓冲图层关闭按钮样式* 
 * @param {Object} [options.axis] 缓冲图层距离轴线
 * @param {Boolean} options.axis.visible 缓冲图层距离轴线是否可见
 * @param {Object} options.axis.style 缓冲图层距离轴线样式
 * @param {Object} [options.label] 缓冲图层距离线标注
 * @param {String} options.label.position 缓冲图层距离线标注位置：middle,left,right,默认为middle
 * @param {Boolean} options.label.visible 缓冲图层距离线标注是否可见
 * @param {Object} options.label.style 缓冲图层距离线标注样式
 * @param {Boolean} [options.fill] 缓冲图层多边形填充配置
 * @param {Boolean} options.fill.visible 缓冲图层多边形样式是否可见
 * @param {Object} options.fill.style 缓冲图层多边形样式
 * @example
 * //使用示例代码
 * //todo
 */
var component = ComponentBase.extend({
    options: {
        name: "缓冲区查询 ",
        radius: 50000,
        buffer_img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAYAAADskT9PAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzdCRTQ5OTYzRkFFMTFFNDk1NTE5ODREMUQwMDhDMzMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzdCRTQ5OTczRkFFMTFFNDk1NTE5ODREMUQwMDhDMzMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDN0JFNDk5NDNGQUUxMUU0OTU1MTk4NEQxRDAwOEMzMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDN0JFNDk5NTNGQUUxMUU0OTU1MTk4NEQxRDAwOEMzMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpA7b9wAAAPDSURBVHjarFZbTxNREJ7d7ba7lbaAgqBUMETEW9OggCYiYIyKJhp+gA/6B4wPhGhMjET9CaivXggxXogkaqLxQXxofCCKFRSjQohRgZa2WLbXXWfWs02tB2ONk3xJe2Z25pvvzDm7Ql9fH3BMQEigaeWQTu8Cw9iB/0sQ1fA3ZhgGCMIs/gojXiGeg8czzwu1cQrbIJWqhETiOOj6YX9LS+X6hga3Q1Gk0rIyB/ylLcZiqaV4PPN5evr7i5GROYhEhpDUFSQS/qVgngJUXIFkcgsWP9dx4IC/pa2t2m63S8bPrqBoEwQzKT5pvHj27Mvj4eGXuHYKSUwWKkBxKmQyjVj8Uld397amnTurdF2HbDYL/8GE5ra2NStcLnloYKAfotFjSOJLPgHZ3F9NO7m3q2uzv7W1KpPJwH81bGaTz1eRTCS2PLx79yKunKBlkaEU9313jdfb3NrevjaLxal7Hvb1BE0U6yNkUE2cqaqtTU17UIUOi4AdUYkE9qCznDon2XkJ9veO5zX0u98yiuOSwLyU37d9+0qcqSMWAdUkoOt1NXV1nmw6bQYW4uDpt7kCDy5s4MbQumUUz4shdau9XjeGNFsEFEQZMnKqTqecpcErwKGz73OJh/vqgRdjgfyW0XOFftoGUZJErFWC2+CysQFUkIAoCoJAAcYfjpxe5KngxRtIRLbbRS2RUMTcMRTFBF4caYPtVT7unfXmHj56foorrQXyW0bPFfpZfiMWiWjgdoeIAFFMIoHw/Oxs3MDLgyft7TNrc4m7L8xwY2jdMornxZC2USouCNMkhmgWx5sTZHn6XTC4INtswFOBcKu36hdpC2EZxfH8lNeG+SffvAkhgadEgGZgCTEHDsfE2Oior76hwbOmtnYVXhjcWRjsqcwdw2J8OF5gk2UIzc1FR548mQRFGbJOASnwDfEVVDVwb2DgYyQcjuKQmHItd6kUA2qEiqeSyaWbV6++B0m6jA2HiIDU2dlJdTLmIEqSDanqrwMBtaa21rGyosJpsARFg3UtoeSKqkIkFIpc6+9/h1t9HUpK7rDGc++CBGLGvBUd+MYVxfjQ4GB8q9+/rtHnK3N7PKq7tFQ1ONIu+/YRRdDi8eRiNKqNjo8vjAYCnzD3DVT5Ptt2I5+Abg4iwAdEClnGaCiDExMbg2Nj61FHD8L9D6/jRWwmhJM3Bi7XI/xN+SPs5P32QUKLMUZiAbEaGU8h3Oy2lIq5f5iq1FTInK+fX0dLzLfsF5HOgpLsASfCweKEIghYc5VCaAzcK/SHAAMA4XIlf6DGCVoAAAAASUVORK5CYII=",
        close_img: "data:image/png;base64,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"
    },

    initialize: function (options) {
        ComponentBase.prototype.initialize.call(this, options);
        var layer = options.layer;
        this._createNewLayer = false;
        if (! (layer instanceof g2.carto.GroupLayer)) {
            layer = new g2.carto.GroupLayer({
                id:options.id||CommonUtil.newUUID32(),
                name:options.name,
                map: this.map,
                zIndex:options.zIndex||100,
                layers: [],
                visible: false,
            });
            this.map.addLayer(layer);
            this._createNewLayer = true;
        }
        this._layer = layer;
        //
        this.bufferList = [];
        //
        this.tool = new BufferTool({
            map: this.map,
        });
        this.tool.onCreate({
            map: this.map,
        });
    },
    
    load(){
        if (!this.isLoaded()) {
            ComponentBase.prototype.load.call(this);
            this._layer.setVisible(true);
            this.tool.onClick();
        }
    },
    unload:function (){
        if (this.isLoaded()) {
            ComponentBase.prototype.unload.call(this);
            this.clearBuffer();
            this.tool.deactivate();
            this._layer.setVisible(false);
        }
    },
    destroy() {
        if (this._createNewLayer) {
            this.map.removeLayer(this._layer);
        }
        ComponentBase.prototype.destroy.call(this);
    },
    /**
     * 展示缓冲区
     * @method
     * @memberOf G.interact.Buffer.prototype
     * @param {Object} opts 配置项
     * @param {String} opts.id 唯一标识
     * @param {String} opts.name 名称
     * @param {Object} opts.data 数据项
     * @param {String} opts.data.type  数据类型:wkt,geojson
     * @param {Object} opts.data.geom 几何对象
     * @param {Object} opts.buffer 缓冲配置项
     * @param {Float} opts.buffer.radius 缓冲半径，单位为米
     * @param {Function} [opts.buffer.callback] 回调函数
     * @param {Function} [opts.buffer.onClose] 关闭
     * @param {Object} [opts.buffer.drag] 缓冲图层半径调节按钮
     * @param {Boolean} opts.buffer.drag.visible 缓冲图层半径调节按钮是否可见
     * @param {Object} opts.buffer.drag.style 缓冲图层半径调节按钮样式
     * @param {Object} [opts.buffer.close] 缓冲图层关闭按钮
     * @param {Boolean} opts.buffer.close.visible 缓冲图层关闭按钮是否可见
     * @param {Object} opts.buffer.close.style 缓冲图层关闭按钮样式
     * @param {Object} [opts.buffer.axis] 缓冲图层距离轴线
     * @param {Boolean} opts.buffer.axis.visible 缓冲图层距离轴线是否可见
     * @param {Object} opts.buffer.axis.style 缓冲图层距离轴线样式
     * @param {Object} [opts.buffer.label] 缓冲图层距离线标注
     * @param {String} opts.buffer.label.position 缓冲图层距离线标注位置：middle,left,right,默认为middle
     * @param {Boolean} opts.buffer.label.visible 缓冲图层距离线标注是否可见
     * @param {Object} opts.buffer.label.style 缓冲图层距离线标注样式
     * @param {Boolean} [opts.buffer.fill] 缓冲图层多边形填充配置
     * @param {Boolean} opts.buffer.fill.visible 缓冲图层多边形样式是否可见
     * @param {Object} opts.buffer.fill.style 缓冲图层多边形样式
     * @param {Object} [opts.buffer.draw] 缓冲图层半径调节按钮
     * @param {Boolean} opts.buffer.draw.visible 缓冲对象是否可见
     * @param {Object} opts.buffer.draw.style 缓冲对象展示样式
     * 
     */
    buffer: function (opts){
        if (this._checkLoaded()) {
            opts.id = opts.id|| CommonUtil.newUUID32();
            opts.buffer = opts.buffer || {};
            opts.buffer.draw = opts.buffer.draw || {};
            this.removeBuffer(opts.id);
            // create layer
            const layer = this._createBufferLayer();
            this._layer.addLayer(layer);
            const bufferObj = this._buffer(layer, opts);
            this.bufferList.push(bufferObj);
        }
    },
    /**
     * 绘制缓冲区
     * @method
     * @memberOf G.interact.Buffer.prototype
     * @param {Object} opts 配置项
     * @param {String} opts.type 绘制类型，point/line/polygon
     * @param {String} opts.id 唯一标识
     * @param {String} opts.name 名称
     * @param {Object} opts.buffer 缓冲配置项
     * @param {Float} opts.buffer.radius 缓冲半径，单位为米
     * @param {Function} [opts.buffer.callback] 回调函数
     * @param {Function} [opts.buffer.onClose] 关闭
     * @param {Object} [opts.buffer.drag] 缓冲图层半径调节按钮
     * @param {Boolean} opts.buffer.drag.visible 缓冲图层半径调节按钮是否可见
     * @param {Object} opts.buffer.drag.style 缓冲图层半径调节按钮样式
     * @param {Object} [opts.buffer.close] 缓冲图层关闭按钮
     * @param {Boolean} opts.buffer.close.visible 缓冲图层关闭按钮是否可见
     * @param {Object} opts.buffer.close.style 缓冲图层关闭按钮样式
     * @param {Object} [opts.buffer.axis] 缓冲图层距离轴线
     * @param {Boolean} opts.buffer.axis.visible 缓冲图层距离轴线是否可见
     * @param {Object} opts.buffer.axis.style 缓冲图层距离轴线样式
     * @param {Object} [opts.buffer.label] 缓冲图层距离线标注
     * @param {String} opts.buffer.label.position 缓冲图层距离线标注位置：middle,left,right,默认为middle
     * @param {Boolean} opts.buffer.label.visible 缓冲图层距离线标注是否可见
     * @param {Object} opts.buffer.label.style 缓冲图层距离线标注样式
     * @param {Boolean} [opts.buffer.fill] 缓冲图层多边形填充配置
     * @param {Boolean} opts.buffer.fill.visible 缓冲图层多边形样式是否可见
     * @param {Object} opts.buffer.fill.style 缓冲图层多边形样式
     * @param {Object} [opts.buffer.draw] 缓冲图层半径调节按钮
     * @param {Boolean} opts.buffer.draw.visible 缓冲对象是否可见
     * @param {Object} opts.buffer.draw.style 缓冲对象展示样式
     */
    drawBuffer: async function(opts) {
        if (this._checkLoaded()) {
            opts.id = opts.id|| CommonUtil.newUUID32();
            opts.buffer = opts.buffer || {};
            opts.buffer.draw = opts.buffer.draw || {};
            this.removeBuffer(opts.id);
            // create layer
            const layer = this._createBufferLayer();
            this._layer.addLayer(layer);
            const bufferObj = await this._drawBuffer(layer,opts);
            this.bufferList.push(bufferObj);
        }
    },

     /**
     * 取消绘制
     * @method
     * @memberOf G.interact.Buffer.prototype
     */   
    cancelDraw: function() {
        this.tool.endDraw();
    },

    /**
     * 设置缓冲区半径
     * @method
     * @memberOf G.interact.Buffer.prototype
     * @param {Float} radius 半径
     * @param {String} [id] 唯一标识，默认为最新的一次缓冲区
     */
    setRadius(radius, id){
        let buffer = this._getBufferById(id, true);
        if (buffer) {
            buffer.options.buffer.radius = radius;
            this.buffer(buffer.options);
        }
    },
    /**
     * 根据id移除
     * @method
     * @memberOf G.interact.Buffer.prototype
     * @param {String} [id] 唯一标识，默认为最新的一次缓冲区
     * 
     */
    removeBuffer(id) {
        let buffer = null;
        for (let i=0;i<this.bufferList.length;i++) {
            const bufferObj = this.bufferList[i];
            if (bufferObj.id === id) {
                buffer = bufferObj;
                this.bufferList.splice(i,1);
                //
                if (buffer.dragTool){
                    this.tool.remove(buffer.dragTool.id);
                }
                if (buffer.closeTool){
                    this.tool.remove(buffer.closeTool.id);
                }
                //
                buffer.layer.clear();
                this._layer.removeLayer(buffer.layer);
                break;
            }
        }
        return buffer;
    },
    /**
     * 清除所有缓冲区
     * @method
     * @memberOf G.interact.Buffer.prototype
     * 
     */
    clearBuffer(){
        this._layer.removeAllLayers();
        this.tool.clear();
        this.bufferList = [];
    },
    /**
     * 获取缓冲多边形
     * @method
     * @memberOf G.interact.Buffer.prototype
     * @param {String} [id] 唯一标识，默认为最新的一次缓冲区
     */
    getBufferGeometry: function(id){
        let buffer = this._getBufferById(id, true);
        if (buffer) {
            const layer = buffer.layer;
            if (layer &&layer.elements.length > 0){
                let elements = layer.elements;
                for (let i=0;i<elements.length; i++){
                    if (elements[i].tag === 'buffer'){
                        return elements[i].geometry;
                    }
                }
            }
        } else {
            console.debug('当前无缓冲！');
        }
        return null;
    },
});
// private
component.include({
    _createBufferLayer() {
        // layer 
        const layer = new g2.carto.ElementLayer({
            id: CommonUtil.newUUID32(),
            map: this.map,
            zIndex: this._layer.zIndex,
        });
        return layer;
    },
    _buffer:function(layer,opts){
        const bufferResult = {};
        if (!opts.buffer.hasOwnProperty('radius')) {
            opts.buffer.radius = this.options.radius;
        }
        opts.buffer.callback = opts.buffer.callback?opts.buffer.callback:this.options.callback;
        opts.buffer.onClose = opts.buffer.onClose?opts.buffer.onClose:this.options.onClose;
        opts.buffer.close = opts.buffer.close?opts.buffer.close:this.options.close;
        opts.buffer.drag = opts.buffer.drag?opts.buffer.drag:this.options.drag;
        opts.buffer.axis = opts.buffer.axis?opts.buffer.axis:this.options.axis;
        opts.buffer.label = opts.buffer.label?opts.buffer.label:this.options.label;
        opts.buffer.fill = opts.buffer.fill?opts.buffer.fill:this.options.fill;
        opts.buffer.drag = opts.buffer.drag?opts.buffer.drag:this.options.drag;
        //原始geom对象
        var _originalGeom = this._geometryConstructor2(opts.data, true);
        //缓冲后geom对象
        var _bufferedGeom = this._getBufferGeom(_originalGeom,opts.buffer.radius);
        //显示缓冲距离轴线的起始点（获取最右侧点，若有相同点，采用最下方点）
        var _startPoint,_endPoint;
        _startPoint = this._getOutmostPoint(_originalGeom);
        _endPoint = this._getOutmostPoint(_bufferedGeom);
        //构造缓冲距离轴线geom
        var path = new g2.sfs.Path({spatialReference: this.map.getSrid()});
        path.addPoint(_startPoint);
        path.addPoint(_endPoint);    
        var _polyline = new g2.sfs.Polyline({
            spatialReference: this.map.spatialReference
        });    
        _polyline.addGeometry(path);
        // 缓冲对象     
        var _bufferTarget = this._elementConstructor(this._geometryConstructor2(opts.data, false),
                opts.buffer.draw.style, 'buffertarget');
        _bufferTarget.id = opts.id;
        //缓冲距离轴线
        var _axisLine = this._elementConstructor(_polyline,opts.buffer.axis?opts.buffer.axis.style:null);
        _axisLine.id = opts.id;
        //填充面
        var _polygon = this._elementConstructor(_bufferedGeom,opts.buffer.fill?opts.buffer.fill.style:null, 'buffer');
        _polygon.id = opts.id;
        //拖拽控制按钮
        if (opts.buffer.drag && opts.buffer.drag.visible) {
            if (!opts.buffer.drag.style.options.source) {
                opts.buffer.drag.style.options.source = this.options.buffer_img;
            }            
        }        
        var _drag = this._elementConstructor(_endPoint,opts.buffer.drag?opts.buffer.drag.style:null, 'drag');
        _drag.id = opts.id;
        //关闭按钮
        if (opts.buffer.close && opts.buffer.close.visible) {
            if (!opts.buffer.close.style.options.source) {
                opts.buffer.close.style.options.source = this.options.close_img;
            }            
        }
        var _close = this._elementConstructor(_endPoint,opts.buffer.close?opts.buffer.close.style:null,'closeButton');
        _close.id = opts.id;        
        //标注
        //确定标注位置
        var _geom = _polyline;
        if (opts.buffer.label) {
            if (opts.buffer.label.position=="middle") {
                var _geom = _polyline
            }else if(opts.buffer.label.position=="left") {
                var _geom = _startPoint
            }else if(opts.buffer.label.position=="right") {
                var _geom = _endPoint
            }
        }
        // 缓冲对象
        if (opts.buffer.draw.visible) {
            layer.add(_bufferTarget);
        }
        //构造标注
        var _label = this._elementConstructor(_geom,opts.buffer.label?opts.buffer.label.style:null);
        _label.id = opts.buffer.id;
        //标注文字
        var _length =this._getLength(_polyline);
        if (_label.symbol) {
            _label.symbol.text = Math.round(_length) / 1000 + "km";
        }
        //缓冲面填充
        if (opts.buffer.fill&&opts.buffer.fill.visible) {
            layer.add(_polygon);
        }        
        //缓冲面轴线
        if (opts.buffer.axis&&opts.buffer.axis.visible) {
            layer.add(_axisLine);
        }
        //关闭按钮
        if (opts.buffer.close&&opts.buffer.close.visible) {
            layer.add(_close);
            //
            const closeTool = new BufferCloseTool({
                bufferId: opts.id,
                layer: layer,
                removeBuffer: this.removeBuffer.bind(this),
                callback: opts.buffer.onClose,
            });   
            closeTool.id = opts.id + '-close';
            bufferResult.closeTool = closeTool; 
            this.tool.add(closeTool);  
        }        
        //缓冲距离标注
        if (opts.buffer.label&&opts.buffer.label.visible) {
            //兼容之前的传参方式
            if (!_label.symbol.source) {
                _label.symbol.source=this.options.buffer_img;
            }
            layer.add(_label);
        }
        //缓冲半径控制按钮
        if (opts.buffer.drag&&opts.buffer.drag.visible) {
            layer.add(_drag);   
            var tool = new BufferDragTool({
                maxPoint: _startPoint,
                bufferMaxPoint: _endPoint,
                geometry: Object.assign({},_originalGeom.asGeoJson()),
                bufferEle: _polygon,
                parent: this,
                callBack: opts.buffer.callback,
                map: this.map,
                drawLayer: layer,
                lineEle: _axisLine,
                closeEle: _close,
                picEle: _drag,
                textEle: _label,
                textPosition:opts.buffer.label?opts.buffer.label.position:null,
                fillsymbol: _polygon.symbol,
                context: opts.buffer.context || this,
            });
            tool.id = opts.id;
            bufferResult.dragTool = tool;   
            //
            this.tool.add(tool);   
        }
        //回调
        if (opts.buffer.callback) {
            opts.buffer.callback.call(this, _bufferedGeom.asGeoJson(), opts.buffer.radius, false);
        }
        //
        bufferResult.id = opts.id;
        bufferResult.layer = layer;
        bufferResult.options = opts;
        return bufferResult;
    },
    _drawBuffer: function(layer, opts) {
        return new Promise((resolve,reject) => {
            const drawOpts = {};
            drawOpts.layer = layer;
            drawOpts.symbol = opts.buffer.draw.style || null;
            drawOpts.callback = function(element) {
                this.tool.endDraw();
                layer.clear();
                opts.data = {
                    type: 'wkt',
                    geom: element.geometry.asWkt(),
                };
                console.debug(opts.data);
                //
                opts.buffer.draw.style = RenderUtil.symbol2Object(element.symbol);
                //
                const jtsGeom =  GeometryUtil.getWktReader().read(opts.data.geom);
                if (jtsGeom.isValid()) {
                    const buffer = this._buffer(layer, opts);
                    resolve(buffer);
                } else {
                    const msg = '绘制图形无效！';
                    this.fire('error', {
                        type: 'draw',
                        message: msg,
                        tag: opts.id,
                    });
                    reject(new Error(msg));
                }
            }
            drawOpts.context = this;
            this.tool.startDraw(opts.type, drawOpts);
        });
    },
    /**
     * 
     * @param {*} id 
     * @param {*} returnLastIfUndefined id未指定时是否返回最近一个
     */
    _getBufferById(id, returnLastIfUndefined) {
        let buffer = null;
        if (this.bufferList.length>0) {
            if (id === undefined && returnLastIfUndefined) {
                buffer = this.bufferList[this.bufferList.length-1];
            } else {
                for(let i=0;i<this.bufferList.length;i++) {
                    if (this.bufferList[i].id === id) {
                        buffer = this.bufferList[i];
                        break;
                    }
                }
            }
        }
        return buffer;
    },
    //计算长度，g2计算有偏差，改用jsts原生计算
    _getLength(geom){
        // var _transformer = new g2.sfs.CoordinateTransform();
        // //将几何对象转为网络墨卡托米制坐标，兼容地理坐标与投影坐标
        // var _originalGeomTransformed = _transformer.transform(geom,3857);
        // var jstsGeom = GeometryUtil.toJstsGeometry(_originalGeomTransformed);
        // return jstsGeom.getLength();
		var projectService = new g2.sfs.CoordinateTransform();
		var measureService = new g2.sfs.MeasureService({ projectService: projectService });
		var length = measureService.length(geom);
		return length;
    },
    //获取最右侧点，作为控制按钮锚点
    _getOutmostPoint(geom){
        var _geoJson = geom.asGeoJson();
        var arr = _geoJson.coordinates;
        var list = this._sortFunction(arr, _geoJson.type);
        var pnt = new g2.sfs.Point({
            x: list[0][0],
            y: list[0][1],
            spatialReference: this.map.getSrid()
        });        
        return pnt;
    },
    //获取缓冲区几何对象
    _getBufferGeom(geom,radius){
        const bufferGeom = G.utils.SpatialOPUtil.getBuffer({
            geometry: geom.asGeoJson(),
            radius: parseFloat(radius),
            spatialReference: 4326,
        });
        var bufferGeomG2 = g2.sfs.GeometryFactory.createGeometryFromGeoJson(bufferGeom,geom.spatialReference);
        return bufferGeomG2;  
        // //坐标转换
        // var _transformer = new g2.sfs.CoordinateTransform();
        // //将几何对象转为网络墨卡托米制坐标，兼容地理坐标与投影坐标
        // var geomNeo = geom;
        // if (geom.spatialReference + '' === '3857') {
        //     geomNeo = _transformer.transform(geom,4326);
        // }
        // var geomType = geomNeo.getGeometryType();
        // var bufferGeoJSON = null;
        // if (geomType + '' === '1') { //点
        //     bufferGeoJSON = this._getCircleGeoJson({
        //         x: geomNeo.x,
        //         y: geomNeo.y,
        //         radius: radius,
        //         count: 128
        //     });
        // } else {
        //     //拓扑计算
        //     var geo = geom.asGeoJson();
        //     var reader = new jsts.io.GeoJSONReader();
        //     var input = reader.read(geo);
        //     var degreeRadius = radius * (360 / (2 * Math.PI * 6378137));
        //     input = input.buffer(degreeRadius);//缓冲buffer米
        //     bufferGeoJSON = new jsts.io.GeoJSONWriter().write(input);
        // }

        // var _bfromgeoufferedGeomTransformed = g2.sfs.GeometryFactory.createGeometryFromGeoJson(bufferGeoJSON,geomNeo.spatialReference);
        // var _bufferedGeom =  _transformer.transform(_bufferedGeomTransformed,geom.spatialReference);
        // return _bufferedGeom;
    },
    //构建g2.sfs.Element
    _elementConstructor(geometry,style,tag){
        var element = new g2.sfs.Element({
            geometry: geometry,
            tag,
        });
        if (!!style) {
            element.symbol=this._symbolConstructor(style);
        }    
        return element;
    },
    //构建_geojson
    _geojsonConstructor(data){
        var geojsonReader = new jsts.io.GeoJSONReader();
        var wktReader = new jsts.io.WKTReader();
        var geom;
        if (data.type.toLowerCase()=="wkt") {
            geom = wktReader.read(geo);
        } else if (data.type.toLowerCase()=="geojson") {
            geom = geojsonReader.read(geo);
        }
        var _geojson = new jsts.io.GeoJSONWriter().write(geom)
        return _geojson;
    },
    //构建g2.sfs.Geometry
    _geometryConstructor(data){
        var geom=new g2.sfs.Geometry();
        if (data.type.toLowerCase()=="wkt") {
            geom = g2.sfs.GeometryFactory.createGeometryFromWkt(data.geom,this.map.getSrid());
        } else if (data.type.toLowerCase()=="geojson") {
            geom = g2.sfs.GeometryFactory.createGeometryFromGeoJson(data.geom,this.map.getSrid());
        }
        return geom;
    },
    //构建g2.sfs.Geometry(通过jsts转换，解决g2无法解析线形问题),待修改完善
    _geometryConstructor2(data, refine){
        var jstsGeom;
        if (data.type.toLowerCase()=="wkt") {
            jstsGeom = GeometryUtil.getWktReader().read(data.geom);
        } else if (data.type.toLowerCase()=="geojson") {
            jstsGeom=GeometryUtil.getGeoJSONReader().read(data.geom);
        }
        //待优化，临时解决
        if (refine === true && jstsGeom.getGeometryType() !== 'Polygon' && jstsGeom.getGeometryType() !== 'Point') {
            jstsGeom = jstsGeom.buffer(0.00001);
        }
        var _geoJSON = new jsts.io.GeoJSONWriter().write(jstsGeom);
        var geom = g2.sfs.GeometryFactory.createGeometryFromGeoJson(_geoJSON,this.map.getSrid());
        return geom;
    },    
    //构建g2.sfs.Symbol
    _symbolConstructor(style){
        var symbol=RenderUtil.object2Symbol(style);
        return symbol;       
    },
    _sortFunction: function (arr, type) {
        var list = [];
        if (type == "LineString") {
            list = arr;
            list.sort(function (a, b) {
                return a[0] < b[0] ? 1 : -1;
            })
        } else if (type == "Point") {
            list.push(arr);
        } else {

            for (var i = 0; i < arr.length; i++) {
                var obj = arr[i];
                for (var j = 0; j < obj.length; j++) {
                    list.push(obj[j]);
                }
            }
            list.sort(function (a, b) {
                return a[0] < b[0] ? 1 : -1;
            })
        }

        return list;
    },
    /**
     * 获取圆的geojson
     * @param x
     * @param y
     * @param radius
     * @param count
     * @returns {{}}
     * @private
     */
    _getCircleGeoJson: function (param) {
        var x = param.x;
        var y = param.y;
        var dist = param.radius;
        var count = param.count;
        var brngs = [];
        var srs = param.srs;
        var geoJson = {};
            for (var i = 0; i < count; i++) {
                var l = 360 / count;
                brngs.push(l * i);
            }
            geoJson.type = "Polygon"
            var coordinates = [];
            dist = dist / 6378137;
            for (var r = 0; r < brngs.length; r++) {
                var brng = brngs[r];
                brng = brng * Math.PI / 180;
                var lat1 = y * Math.PI / 180, lon1 = x * Math.PI / 180;
                var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dist) +
                    Math.cos(lat1) * Math.sin(dist) * Math.cos(brng));
                var lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dist) *
                    Math.cos(lat1),
                    Math.cos(dist) - Math.sin(lat1) *
                    Math.sin(lat2));
                if (!isNaN(lat2) || !isNaN(lon2)) {
                    var point = [];
                    var ox = lon2 * 180 / Math.PI;
                    var oy = lat2 * 180 / Math.PI;
                    point.push(ox);
                    point.push(oy);
                    coordinates.unshift(point);
                    if (r == brngs.length - 1) {
                        coordinates.push(coordinates[0]);
                    }
                }
                ;
            }
            geoJson.coordinates = [coordinates];

        return geoJson;
    }    
});
module.exports= component;
